module.exports = __webpack_public_path__ + "img/hedwig-logo.1dc78ea5.png";